class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.mainDetailsToggle.addEventListener('click', this.onFocusOut.bind(this));
        
        // Add click event listener to the document
        document.addEventListener('click', this.onClickOutside.bind(this));
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    onClickOutside(event) {
        if (!this.contains(event.target) && this.mainDetailsToggle.hasAttribute('open')) {
            this.close();
        }
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
}

customElements.define('details-disclosure', DetailsDisclosure);